import _ from "lodash";
import * as React from "react";
import { faultComparator, getDomainDisplayName, createElementKey } from "../../utils/utils";
import FaultListItem from "../FaultListItem/FaultListItem";
import styles from "./FaultListGroupItem.module.scss";
import FaultListGroupIcon from "../icons/FaultListGroup";
import chevronDown from "../../assets/chevron-down-blue.svg";
import { useState } from "react";

type FaultListGroupItemProps = {
  groupItem: Api.AnyFault;
  childItems: Api.AnyFault[];
  faultPriorities: Api.FaultPriority[];
  faultDomains: Api.Domains;
  onItemClick: (
    resultType: number,
    code: any,
    domainId: any,
    inElectrification?: number,
    inCategoryDomain?: number
  ) => void;
  selectedFault: Api.AnyFault | null;
  domain: Api.Domain;
  eleEnumValue: number;
  openByUrlParam: boolean;
};

const FaultListGroupItem: React.FC<FaultListGroupItemProps> = ({
  groupItem,
  childItems,
  faultPriorities,
  faultDomains,
  onItemClick,
  selectedFault,
  domain,
  eleEnumValue,
  openByUrlParam
}: FaultListGroupItemProps) => {
  const selectedItemIsInGroup = !!childItems.find(
    fault =>
      fault.code === selectedFault?.code &&
      fault.domain?.id === selectedFault?.domain?.id &&
      fault.inElectrification == selectedFault?.inElectrification &&
      groupItem.domain?.id === selectedFault?.domain?.id
  );

  React.useEffect(() => {
    // open collapse, if selected fault is in group
    if (
      (!!selectedFault?.code &&
        !!selectedFault?.domain?.id &&
        collapsed &&
        selectedItemIsInGroup) ||
      openByUrlParam
    ) {
      setCollapsed(false);
    }
  }, [selectedFault]);

  const [collapsed, setCollapsed] = useState(true); // initially collapsed
  const domainsAsArray = _.values(faultDomains);
  const selected =
    selectedFault?.code === groupItem.code && selectedFault?.domain?.id === groupItem.domain?.id;

  const mainClasses = selected
    ? [styles.FaultGroupItem, styles.FaultGroupItemSelected]
    : [styles.FaultGroupItem];

  const groupElement = (
    <div className={mainClasses.join(" ")} onClick={() => setCollapsed(!collapsed)}>
      <div className={styles.FaultGroupItemSymbolDiv}>
        <FaultListGroupIcon />
      </div>
      <div className={styles.FaultGroupItemNameMobile}>
        <span className={styles.FaultGroupItemDomain}>
          {getDomainDisplayName(domain) + " (" + domain?.enumValue + ")"}
        </span>
        <span>{groupItem.name}</span>
      </div>
      <div className={styles.FaultGroupItemNameDesktop}>
        {getDomainDisplayName(domain) + " (" + domain?.enumValue + ")"}
      </div>
      <div className={styles.FaultGroupItemCodeDiv}>{groupItem.code}</div>
      <div className={styles.FaultGroupItemNameDesktop}>{groupItem.name}</div>
      <div className={styles.DropdownToggle}>
        <img
          alt="Collapse"
          src={chevronDown}
          className={collapsed ? styles.LogoToBackwardsIcon : styles.BackwardsIconToLogo}
        />
      </div>
    </div>
  );
  const groupElementMobile = (
    <div
      className={mainClasses.join(" ")}
      onClick={() =>
        onItemClick(
          groupItem.resultType,
          groupItem.code,
          groupItem.domain?.id,
          groupItem.inElectrification,
          groupItem.inCategoryDomain
        )
      }
    >
      <div className={styles.FaultGroupItemSymbolDiv}>
        <FaultListGroupIcon />
      </div>
      <div className={styles.FaultGroupItemNameMobile}>
        <span className={styles.FaultGroupItemDomain}>
          {getDomainDisplayName(domain) + " (" + domain?.enumValue + ")"}
        </span>
        <span>{groupItem.name}</span>
      </div>
      <div className={styles.FaultGroupItemNameDesktop}>
        {getDomainDisplayName(domain) + " (" + domain?.enumValue + ")"}
      </div>
      <div className={styles.FaultGroupItemCodeDiv}>{groupItem.code}</div>
      <div className={styles.FaultGroupItemNameDesktop}>{groupItem.name}</div>
    </div>
  );

  const childrenFaultElements = childItems
    .sort(faultComparator(domainsAsArray))
    .map((fault: Api.AnyFault) => {
      if (!fault?.domain) return null;
      // get priority data from id  for fault
      const faultPriority: any = faultPriorities.filter(
        (priority: any) => priority.id === fault.priority?.id
      )[0];
      // get domain data from id for fault
      const faultDomain: any = domainsAsArray.filter(
        (domain: any) => domain.id === fault.domain.id
      )[0];

      return (
        <FaultListItem
          selected={
            selectedFault?.code === fault.code &&
            selectedFault?.domain?.id === fault.domain.id &&
            selectedFault?.inElectrification == fault.inElectrification
          }
          key={createElementKey(eleEnumValue, groupItem.id, fault.domain.id, fault.id)}
          fault={fault}
          priority={faultPriority}
          domain={faultDomain}
          onItemClick={onItemClick}
          indentation={50}
          hidden={collapsed}
        />
      );
    });
  return (
    <>
      <div className={styles.OnlyInMobile}>{groupElementMobile}</div>
      <div className={styles.OnlyInDesktop}>{groupElement}</div>
      <div className={styles.OnlyInDesktop}>
        <div>{childrenFaultElements}</div>
      </div>
    </>
  );
};

export default FaultListGroupItem;
